<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">How long does it take for me to get paid?</h1>
			<p>
				Transporting the book can take 5-10 business days, with an additional 5 business days required by the buyback agent to process the shipment. We will pay you on the 7th and 22nd of each month following confirmed receipt from the buyback agent.
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "HowLongDoesItTakeForMeToGetPaid",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>